import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_flAdvDirectivesAdult = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_flAdvDirectivesAdult' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Healthcare Surrogate</h3></p>

                <p className='w-750'>I understand that I have the right to name a health care surrogate in the event I am determined to be incapacitated
                    to make decisions regarding my mental health or medical treatment. I understand that a healthcare surrogate
                    designee
                    is allowed to make healthcare decisions for me, can provide, withold, or withdraw consent on my behalf, can apply
                    for public benefits to defray the cost of healthcare, and can authorize my admission to or transfer from a medical
                    or mental health treatment facility. I also understand that making a designation of a healthcare surrogate is not
                    a condition for treatment in or admission to a medical or mental health facility.</p>


                <p className='w-750'><h3>Uniform Organ Donation</h3></p>

                <p className='w-750'>I understand that I have the right to make designations regarding the donation of my body or parts of my body for
                    the
                    purposes of transplantation, therapy, medical research, or education. I also understand that making a designation
                    regarding the donation of my body or parts of my body is not a condition for treatment in or admission to a medical
                    of mental health facility.</p>

                <p className='w-750'><h3>Living Will</h3></p>


                <p className='w-750'>I understand that I have the right to create a living will for myself, which will allow me to make designations
                    regarding healthcare surrogacy, uniform organ donation, and more.</p>
                    
                <p className='w-750'>By signing below, I acknowledge that I have received and understand my advance directive rights as stated above.</p>

            </div>
        </form>

    )
}

